module.exports = __webpack_public_path__ + "img/xenia.53653022.png";